import { isEqual } from 'lodash';
import React from 'react';

import type { Props as IframeProps } from '@swf/components/Iframe/Iframe';
import Iframe from '@swf/components/Iframe/Iframe';
import useResolver from '@swf/core/hooks/useResolver';
import type { FetchTagPayload } from '@swf/core/models/resolver';
import { getState, select } from '@swf/core/store';
import { replaceHost } from '@swf/core/utils/domains';

export type Props = {
  tag: string | FetchTagPayload;
  query?: object;
  mitIdData?: object;
  host?: string;
} & IframeProps;

const ResolverIframe: React.FC<Props> = ({ tag, query, mitIdData, host, ...rest }) => {
  const state = getState();
  const language = select.locale.get(state);
  const country = select.account.getCountry(state);
  const site = select.site.getId(state);
  const userId = select.account.getUserId(state);
  const timezone = select.account.getTimezone(state);
  const userWebId = select.session.getWebId(state);
  const tagValue = typeof tag === 'string' ? tag : tag?.tag;
  const url = useResolver(tagValue, {
    query: {
      language,
      country,
      site,
      platform: 'Web',
      userId,
      timezone,
      ...query,
      ...mitIdData,
      TimeZoneId: timezone,
      u: userWebId // Must be a last for license migration app
    }
  });
  return url ? (
    <Iframe
      key={url}
      src={decodeURIComponent(host ? replaceHost(url, host) : url)}
      tag={tag}
      {...rest}
    />
  ) : null;
};

export default React.memo(ResolverIframe, isEqual);
